module.exports = __webpack_public_path__ + "img/18.de2c604c.png";